import React from "react"

import { ScrollRevealItem } from "../../WebsiteBuilderV2/components/shared/ScrollReveal"

import ProCard from "./ProCard"

/**
 * Practitioner card link with scroll-triggered stagger (homepage landing grids).
 */
const ProCardGridItem = ({ practitioner, index, isMobile, href }) => (
  <ScrollRevealItem staggerIndex={index + 1} variant="fadeUp" className="block h-full">
    <a href={href} className="group block h-full transition-transform duration-300 hover:-translate-y-0.5">
      <ProCard data={practitioner} mobile={isMobile} />
    </a>
  </ScrollRevealItem>
)

export default ProCardGridItem
